const StatsCard = ({ icon, label, value, borderColor = "border-brand" }) => {
  return (
    <div className={`bg-white rounded-lg shadow-md p-6 border-l-4 ${borderColor}`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{label}</p>
          <p className="text-4xl font-bold text-brand mt-2">{value}</p>
        </div>
        {icon && (
          <div className="text-brand text-4xl opacity-75">
            <i className={`fa ${icon}`}></i>
          </div>
        )}
      </div>
    </div>
  )
}

export default StatsCard
